import { connect } from 'react-redux';
import DashboardSnapshotCards from './DashboardSnapshotCards';
import { instrumentSelectorInstruments } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { productPositionAssetsSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';

const PREFERRED_BASE_SYMBOLS = ['BTC', 'ETH', 'USDT'];

function rowForInstrument(instrument, products, level1) {
  const level1Data = level1[instrument.InstrumentId];
  if (!level1Data) {
    return null;
  }
  const product1 = products.find(p => p.ProductId === instrument.Product1);
  const product2 = products.find(p => p.ProductId === instrument.Product2);
  if (!product1 || !product2) {
    return null;
  }
  return { instrument, product1, product2, level1Data };
}

function pickSnapshotRows(state) {
  const instruments = instrumentSelectorInstruments(state);
  const products = productPositionAssetsSelector(state);
  const level1 = state.apexCore.level1;
  const withL1 = instruments.filter(i => level1[i.InstrumentId]);
  const out = [];
  const used = new Set();

  for (const sym of PREFERRED_BASE_SYMBOLS) {
    const inst = withL1.find(i => i.Product1Symbol === sym);
    if (!inst || used.has(inst.InstrumentId)) {
      continue;
    }
    const row = rowForInstrument(inst, products, level1);
    if (row) {
      out.push(row);
      used.add(inst.InstrumentId);
    }
  }

  for (const inst of withL1) {
    if (out.length >= 3) {
      break;
    }
    if (used.has(inst.InstrumentId)) {
      continue;
    }
    const row = rowForInstrument(inst, products, level1);
    if (row) {
      out.push(row);
      used.add(inst.InstrumentId);
    }
  }

  return out.slice(0, 3);
}

const mapStateToProps = state => ({
  cards: pickSnapshotRows(state)
});

export default connect(mapStateToProps)(DashboardSnapshotCards);
